import type { IconSvgObject } from './types';

const EcoEnergyIcon: IconSvgObject = [
  ["path", { d: "M9.5 4.5L9.95918 2C5.96094 2.8116 2.8116 5.96094 2 9.95918M19.5 9.5L22 9.95918C21.1884 5.96094 18.0391 2.8116 14.0408 2M14.5 19.5L14.0408 22C18.0391 21.1884 21.1884 18.0391 22 14.0408M9.95918 22C5.96094 21.1884 2.8116 18.0391 2 14.0408L4.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 11C12 11 8.58904 12.8242 8.58904 16.5M8.58904 12.6083L9.0222 13.9773L10.3912 14.4105C14.7619 15.2051 15.4995 10.5 15.4995 7.5C12.5 7.5 7.79437 8.23761 8.58904 12.6083Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default EcoEnergyIcon;
